import React from "react";
import DeclarationLayout, { Point } from "./DeclarationLayout";

// Student admission declaration & terms (opened from the student admission
// form). Bilingual (English + Hindi).
export default function StudentDeclaration() {
  return (
    <DeclarationLayout
      title="Student Admission Form"
      subtitle="Declaration, Terms & Conditions / विद्यार्थी घोषणा-पत्र, नियम एवं शर्तें"
      crumbLabel="Student Admission Declaration"
    >
      <div className="decl-intro">
        This document forms an integral part of the Student Admission Form for
        admission/training at an NSVEC-approved/authorized centre, wherever
        applicable.
        <br />
        <span className="hi">
          यह दस्तावेज़ NSVEC के approved/authorized centre में प्रवेश/प्रशिक्षण हेतु
          Student Admission Form का अभिन्न भाग होगा, जहाँ लागू हो।
        </span>
      </div>

      <Point
        heading="1. Accuracy of Information / जानकारी की सत्यता"
        en="I declare that all information provided by me in the admission form and supporting documents is true, correct and complete to the best of my knowledge."
        hi="मैं घोषणा करता/करती हूँ कि admission form एवं संबंधित documents में मेरे द्वारा दी गई सभी जानकारी मेरी जानकारी के अनुसार सत्य, सही एवं पूर्ण है।"
      />
      <Point
        heading="2. Genuine Documents / वास्तविक दस्तावेज"
        en="I shall submit genuine and valid educational/identity or other documents required for admission. If any document or information is found false, forged or misleading, admission may be cancelled in accordance with applicable rules."
        hi="मैं प्रवेश हेतु आवश्यक वास्तविक एवं वैध educational/other documents प्रस्तुत करूँगा/करूँगी। कोई document या information false, forged या misleading पाए जाने पर लागू नियमों के अनुसार admission cancel किया जा सकता है।"
      />
      <Point
        heading="3. Eligibility / पात्रता"
        en="I confirm that I meet the eligibility requirements applicable to the selected course/programme. Admission remains subject to verification and approval under the applicable rules."
        hi="मैं पुष्टि करता/करती हूँ कि selected course/programme की लागू eligibility requirements पूरी करता/करती हूँ। Admission verification एवं applicable rules के अधीन रहेगा।"
      />
      <Point
        heading="4. Course & Centre Scope / पाठ्यक्रम एवं Centre का दायरा"
        en="I understand that I am admitted only to the course/programme and centre stated in my admission record. Any change shall require approval through the prescribed process."
        hi="मैं समझता/समझती हूँ कि मेरा admission केवल admission record में दर्ज course/programme एवं centre के लिए है। किसी भी परिवर्तन हेतु निर्धारित प्रक्रिया से approval आवश्यक होगा।"
      />
      <Point
        heading="5. Attendance & Discipline / उपस्थिति एवं अनुशासन"
        en="I shall maintain the attendance, discipline and conduct requirements prescribed by the centre and applicable NSVEC rules."
        hi="मैं centre एवं लागू NSVEC rules के अनुसार attendance, discipline एवं conduct requirements का पालन करूँगा/करूँगी।"
      />
      <Point
        heading="6. Fees / शुल्क"
        en="I shall pay course, training, examination or other applicable fees as communicated by the authorized centre. Official receipts should be obtained for payments."
        hi="मैं authorized centre द्वारा निर्धारित course, training, examination एवं अन्य applicable fees का भुगतान करूँगा/करूँगी। प्रत्येक भुगतान की official receipt प्राप्त करूँगा/करूँगी।"
      />
      <Point
        heading="7. Examination & Assessment / परीक्षा एवं मूल्यांकन"
        en="I understand that examination, assessment and completion/certification, where applicable, are subject to the prescribed eligibility, attendance, assessment and examination requirements."
        hi="मैं समझता/समझती हूँ कि जहाँ लागू हो, examination, assessment एवं completion/certification निर्धारित eligibility, attendance, assessment एवं examination requirements के अधीन होंगे।"
      />
      <Point
        heading="8. Certificate / प्रमाण-पत्र"
        en="No certificate shall be promised or issued except through the applicable authorized process. Admission alone does not guarantee successful completion or certification."
        hi="किसी भी certificate का promise अथवा issue केवल लागू authorized process के माध्यम से होगा। केवल admission से successful completion या certification की guarantee नहीं होती।"
      />
      <Point
        heading="9. Use of Name / नाम एवं Logo"
        en="I shall not misuse the name, logo, certificate, ID card, centre code or other official credentials of NSVEC or the centre."
        hi="मैं NSVEC अथवा centre के नाम, logo, certificate, ID card, centre code या अन्य official credentials का दुरुपयोग नहीं करूँगा/करूँगी।"
      />
      <Point
        heading="10. Government / Statutory Representation"
        en="I understand that admission or course enrolment shall not by itself be represented as a Government job, Government appointment, statutory licence or Government recognition unless separately supported by competent authority."
        hi="मैं समझता/समझती हूँ कि admission अथवा course enrolment को अपने-आप Government job, Government appointment, statutory licence या Government recognition के रूप में प्रस्तुत नहीं किया जा सकता, जब तक competent authority से अलग आधार न हो।"
      />
      <Point
        heading="11. Student Records / विद्यार्थी अभिलेख"
        en="I shall provide updated information where required and cooperate in verification of my admission, attendance, assessment and course records."
        hi="आवश्यकता होने पर मैं updated information दूँगा/दूँगी तथा admission, attendance, assessment एवं course records के verification में सहयोग करूँगा/करूँगी।"
      />
      <Point
        heading="12. Code of Conduct / आचार संहिता"
        en="I shall maintain respectful, ethical and lawful conduct within the centre and during NSVEC-related activities. Misconduct may lead to disciplinary action under applicable rules."
        hi="मैं centre एवं NSVEC-related activities के दौरान respectful, ethical एवं lawful conduct बनाए रखूँगा/रखूँगी। Misconduct होने पर लागू rules के अनुसार disciplinary action लिया जा सकता है।"
      />
      <Point
        heading="13. Safety & Property / सुरक्षा एवं संपत्ति"
        en="I shall follow safety instructions and shall not intentionally damage centre property, equipment, records or facilities."
        hi="मैं safety instructions का पालन करूँगा/करूँगी तथा centre की property, equipment, records या facilities को जानबूझकर नुकसान नहीं पहुँचाऊँगा/पहुँचाऊँगी।"
      />
      <Point
        heading="14. Withdrawal / प्रवेश वापसी"
        en="Any withdrawal, transfer or discontinuation request shall be submitted through the prescribed process. Refund, if any, shall be governed by the applicable fee/refund policy of the centre/authority."
        hi="withdrawal, transfer अथवा discontinuation का request निर्धारित process के माध्यम से किया जाएगा। Refund, यदि कोई हो, तो centre/authority की applicable fee/refund policy के अनुसार होगा।"
      />
      <Point
        heading="15. Admission Cancellation / प्रवेश निरस्तीकरण"
        en="Admission may be suspended or cancelled in accordance with applicable rules for false documents, material misrepresentation, serious misconduct, non-compliance or other substantial grounds."
        hi="false documents, material misrepresentation, serious misconduct, non-compliance या अन्य substantial grounds पर applicable rules के अनुसार admission suspend/cancel किया जा सकता है।"
      />
      <Point
        heading="16. Complaints / शिकायत"
        en="I may raise academic, administrative or admission-related grievances through the centre's prescribed grievance process and, where applicable, the designated NSVEC process."
        hi="मैं academic, administrative अथवा admission-related grievance के लिए centre की prescribed grievance process तथा जहाँ लागू हो designated NSVEC process का उपयोग कर सकता/सकती हूँ।"
      />
      <Point
        heading="17. Change of Contact Details / संपर्क विवरण में परिवर्तन"
        en="I shall inform the centre of material changes in my mobile number, email or address so that official communication can reach me."
        hi="mobile number, email या address में महत्वपूर्ण परिवर्तन होने पर मैं centre को सूचित करूँगा/करूँगी ताकि official communication प्राप्त हो सके।"
      />

      <div className="decl-final">
        <h3>18. Final Acceptance / अंतिम स्वीकृति</h3>
        <p>
          I have read and understood this Declaration and Terms &amp; Conditions and
          voluntarily agree to comply with the applicable admission, centre and
          NSVEC rules.
        </p>
        <p className="hi">
          मैंने इस Declaration एवं Terms &amp; Conditions को पढ़कर समझ लिया है और
          स्वेच्छा से लागू admission, centre एवं NSVEC rules का पालन करने के लिए सहमत
          हूँ।
        </p>
      </div>
    </DeclarationLayout>
  );
}
